<template>
  <div>
    <Card
      :row="row"
      :class="
        [workingHour.length > 3 ? 'rhg-spa-card working-hours' : 'rhg-spa-card rhg-spa-card--horizontal-alignment', numberOfCards < 4 ? 'rhg-spa-card--horizontal-alignment' : '']
      "
    >
      <template v-if="picture" v-slot:header>
        <div class="rhg-spa-image-wrapper">
          <picture class="rhg-spa-image zoom-on-hover"
            :class="numberOfCards < 4 ? 'rhg-spa-image--horizontal-image' : ''">
            <img :src="`${picture}?impolicy=SecondGalleryImg`" :alt="title" />
          </picture>
        </div>
      </template>
      <div class="rhg-spa-card-body">
        <div class="rhg-spa-card-info">
          <typography v-if="title" size="xl" tag="h2" strong>{{title}}</typography>
          <typography v-if="description" tag="p" size="sm">{{description}}</typography>
          <ButtonLink
            v-if="link"
            tag="a"
            :label="link.text"
            :to="link.url"
            variant="primary"
            size="md"
            icon="right"
            isCapitalized
          />
        </div>
        <hours-grid
          v-if="workingHour.length < 4 "
          :hours="workingHour"
          :class="workingHour"
        />
        <hours-grid
        v-if="workingHour.length > 3"
        class="rhg-spa-card-four-hours-mobile"
        :hours="workingHour"
      />
      </div>
    </Card>
    <hours-grid
      v-if="workingHour.length > 3"
      class="rhg-spa-card-four-hours-desktop"
      :hours="workingHour"
    />
  </div>
</template>

<script>
import Card from '../../../Atoms/Cards/Card'
import Typography from '../../../Atoms/typography/Typography.vue'
import HoursGrid from '../hours-grid/HoursGrid.vue'
import ButtonLink from '../../../Atoms/button-link/ButtonLink'

export default {
  name: 'CardSpa',
  components: { Card, Typography, HoursGrid, ButtonLink },
  props: {
    row: {
      type: Boolean
    },
    title: {
      type: String,
      required: true
    },
    workingHour: {
      type: Array,
      required: true
    },
    description: {
      type: String
    },
    picture: {
      type: String
    },
    link: {
      type: Object
    },
    numberOfCards: {
      type: Number
    },
    swiperInitialized: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    numberOfCards (newVal) {
      if (newVal > 3) {
        this.adjustCardHeights()
      }
    },
    swiperInitialized () {
      if (this.$props.numberOfCards > 3) {
        this.adjustCardHeights()
      }
    }
  },
  mounted () {
    if (this.numberOfCards > 3) {
      this.adjustCardHeights()
    }
  },
  methods: {
    adjustCardHeights () {
      if (this.swiperInitialized) {
        const cards = document.querySelectorAll('.rhg-spa-card-body')
        let maxHeight = 0

        cards.forEach((card) => {
          const cardHeight = card.scrollHeight
          if (cardHeight > maxHeight) {
            maxHeight = cardHeight
          }
        })

        const adjustedHeight = Math.ceil(maxHeight) + 3

        cards.forEach((card) => {
          card.style.height = adjustedHeight + 'px'
        })

        this.maxCardHeight = adjustedHeight
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../Common/Colors.scss";

.rhg-spa-card {
  display: flex;
  align-content: center;
  flex-wrap: wrap;

  &--horizontal-alignment {
    flex-wrap: nowrap;
    padding-bottom: 0;
  }
  img {
    width: -webkit-fill-available;
    overflow: hidden;
  }
  &.working-hours {
    border-radius: 0.68rem;
  }
  .rhg-card-body {
    padding: 48px;
    width: 100%;
  }
  .rhg-spa-card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 100%;

    &--full-width {
      width: 100%;
    }
  }
  .rhg-spa-card-info{
    p {
      line-height: 20px;
    }
     h2 {
      padding-bottom: 16px;
     }
  }
  .rhg-spa-card.rhg-card-row {
    display: grid;
    grid-template-columns: 30% 1fr 0px;

    img {
      height: 100%;
      width: -webkit-fill-available;
      object-fit: cover;
      overflow: hidden;
    }
  }

  .rhg-hours-grid {
    border: unset;
    padding: initial;
  }

  .rhg-spa-image {
    height: 100%;
    width: 100%;
    overflow: hidden;
    height: 180px;
    object-fit: cover;

    &--horizontal-image {
      width: 414px;
      height: 100%;
      display: flex;

      img  {
        width: 100%;
        object-fit: cover;
      }
    }
  }

  .rhg-slider-slide .rhg-card {
    border-bottom: none;
  }

  .rhg-spa-image-wrapper {
    width: 414px;
    height: auto;
  }
}

.rhg-spa-card-four-hours-desktop {
  background-color: rgb(255, 255, 255);
  border: 1px solid $medium-gray;
  border-radius: 0 0 0.68rem 0.68rem;
  justify-content: space-between;
  padding: 23px 57px;
  i {
    margin-right: 8px;
  }
}
.rhg-spa-card-four-hours-mobile {
  display:none!important;
}

@media (max-width:992px) {
  .rhg-spa-card .rhg-card-body {
    padding: 24px;
    width: 100%;
  }
  .rhg-spa-card-body {
    padding: 0;
  }
  .rhg-spa-card.rhg-card-row {
    display: flex;
    grid-template-columns: unset;
    flex-direction: column;
    img {
      width: -webkit-fill-available;
    }
  }
  .rhg-spa-card .rhg-spa-image-wrapper,
  .rhg-spa-card .rhg-spa-image--horizontal-image{
    width: 100%;
    height: 180px;
  }
  .rhg-spa-card-four-hours-desktop {
    display: none!important;
  }
  .rhg-spa-card-four-hours-mobile {
    display: flex!important;
    background-color: white;
    border-top: unset;
    border-radius: 0 0 0.68rem 0.68rem;
  }
}

html[dir='rtl'] {
  img {
    overflow: hidden;
  }
  .rhg-spa-card-info, p, h3{
    text-align: right;
  }
}
</style>
